import unorm from 'unorm';

const clean = (text?: string) => {
  if (text) {
    return unorm
      .nfd(text)
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  }
};

export { clean };
